import { render } from "./onePerformer.vue?vue&type=template&id=7a05d0a6"
import script from "./onePerformer.vue?vue&type=script&lang=js"
export * from "./onePerformer.vue?vue&type=script&lang=js"

import "./onePerformer.vue?vue&type=style&index=0&id=7a05d0a6&lang=css"

import exportComponent from "/var/www/__turkey-24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__